<template>
  <div>
    <router-view />
  </div>
</template>

<script>


  export default {
    name: 'ProductSheetBaseView',

    data () {
      return {
      }
    },
  }
</script>

<style>

</style>
